import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Text, Box, Checkbox, Flex, ListItem } from "@chakra-ui/react";
import {
  getTemplate,
  deleteTemplate,
} from "../../redux/actions/templateActions";

const actionTypes = {
  edit: "edit",
  entries: "entries",
  preview: "preview",
  delete: "delete",
};

const FormListItem = ({
  title,
  templateId,
  created,
  dispatchGetTemplate,
  onClickPreviewHandler,
  onChangeCheckBox,
  isChecked,
  allChecked,
  dispatchDeleteTemplate,
}) => {
  const [redirectEntriesPage, setRedirectEntriesPage] = useState(false);
  const handleAction = (type) => {
    switch (type) {
      case actionTypes.edit: {
        if (templateId.includes("default")) {
          return dispatchGetTemplate(templateId, "default");
        }
        return dispatchGetTemplate(templateId);
      }
      case actionTypes.delete: {
        return dispatchDeleteTemplate(templateId);
      }
      case actionTypes.entries: {
        return setRedirectEntriesPage(true);
      }
    }
  };
  return (
    <ListItem className="form-list-item" w="100%">
      {redirectEntriesPage && (
        <Redirect
          to={{
            pathname: "form-entries",
            formId: templateId,
          }}
        />
      )}
      <Flex justify="space-between" w="100%">
        <Box p="3" w="58%">
          <Flex alignItems="start" 
          style={{  
            alignItems: "baseline"}}>
            <Checkbox
              name={templateId}
              key={templateId}
              isChecked={allChecked ? true : isChecked[templateId]}
              onChange={(e) => {
                onChangeCheckBox(e, templateId);
              }}
            ></Checkbox>
            <Box ml="14px">
              <Text ml="3" fontWeight="600" color="#3871AC">{title}</Text>
              <Flex
                ml="1"
                className="form-list-item__actions"
                alignItems="center"
                color="#3871AC"
              >
                <span onClick={() => handleAction(actionTypes.edit)}>Edit</span>
                {"|"}
                <span onClick={() => handleAction(actionTypes.entries)}>
                  Entries
                </span>
                {"|"}
                <span onClick={() => onClickPreviewHandler(templateId)}>
                  Preview
                </span>
                {"|"}
                <span
                  className="delete-action"
                  onClick={() => handleAction(actionTypes.delete)}
                >
                  Delete
                </span>
              </Flex>
            </Box>
          </Flex>
        </Box>
        <Box p="3" w="32%">
          <Text pl="3%">{`[fwforms-id=${templateId}]`}</Text>
        </Box>
        <Box p="3" w="10%">
          <Text  color="#3871AC">{created}</Text>
        </Box>
      </Flex>
    </ListItem>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetTemplate: bindActionCreators(getTemplate, dispatch),
    dispatchDeleteTemplate: bindActionCreators(deleteTemplate, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(FormListItem);
